import { AddressType } from '../settings/types/Address';

export const getDeliveryAddressType = (country: string): AddressType => {
  return country.toLowerCase() === 'cz' ? 'print' : 'paper';
};
